export { VaaEmbed } from './VaaEmbed.js';
